// Restore selected variant media after native gallery reinstalls at the mobile breakpoint.
(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const pending = new WeakMap();
  mobile.addEventListener('change', () => {
    document.querySelectorAll('#MainContent .section-main-product media-gallery').forEach(gallery => {
      if (gallery.hasAttribute('data-media-stack')) return;
      const viewer = gallery.querySelector('product-media-slider');
      if (!viewer || typeof viewer.slideByElement !== 'function') return;
      pending.get(viewer)?.();
      let timeout;
      const cleanup = () => {
        observer.disconnect();
        clearTimeout(timeout);
        pending.delete(viewer);
      };
      const observer = new MutationObserver(() => {
        if (!viewer.initSliderStatus) return;
        cleanup();
        const media = viewer.querySelector('.is-current-variant-media');
        if (media) viewer.slideByElement(media, true);
      });
      observer.observe(viewer, { attributes: true, attributeFilter: ['class'] });
      timeout = setTimeout(cleanup, 2000);
      pending.set(viewer, cleanup);
    });
  });
})();
